import LoginPage from "views/auth/login.page";
import ResetPassword from "views/auth/resetPassword.page";
import RegisterPage from "views/auth/register.page";
import RecoverPage from "views/auth/recoverPasswordAsk";
import DashboardPage from "views/admin/dashboard/dashboard.page";
import ValidateTutor from "views/admin/dashboard/validateTutor.page";
import IndexPage from "./views/auth/index";
import ContactPage from "./views/auth/contact";
import RedirectPage from "./views/admin/redirect/index";
import QuestionnairePage from "./views/admin/assessment/index";
import CeibaPage from "./views/admin/assessment/ceiba";
import CervoPage from "./views/admin/assessment/cervo/cervo";
import TekPage from "./views/admin/assessment/tek/tek";
import AssessmentPage from "./views/admin/questionnaires/assessment";
import StartCeibaPage from "./views/admin/assessment/startCeiba";
import StartTekPage from "./views/admin/assessment/tek/startTek";
import CervoGame from "./views/admin/assessment/cervo/cervoGame";
import StartCervoPage from "./views/admin/assessment/cervo/startCervo";
import EndCervoPage from "./views/admin/assessment/cervo/endCervo";
import EndCeibaPage from "./views/admin/assessment/endCeiba";
import StartXcelencePage from "./views/admin/assessment/xcelence";
import StartNogam3Page from "./views/admin/assessment/nogam/nogam3/nogam3";
import StartNogam4Page from "./views/admin/assessment/nogam/nogam4/nogam4";
import StartNogam5Page from "./views/admin/assessment/nogam/nogam5/nogam5";
import StartNogam6Page from "./views/admin/assessment/nogam/nogam6/nogam6";
import CeibaGame from "./views/admin/assessment/ceibaGame";
import DescargaExcel from "./views/admin/informes/downExcel";
import StudentsPage from "./views/admin/tutor/tutor";

import AccountUserView from "./views/admin/account/account";
import ActivateCenter from "./views/tutorAuth/activatecenter";
import LoginFamily from "./views/auth/loginfamily";
import Messages from "./views/admin/messages/messages";
//TUTOR pages
import LoginPageTutor from "views/tutorAuth/login.page";
import HomePageTutor from "views/tutorAuth/home.page";
import ResetPasswordTutor from "views/tutorAuth/resetPassword.page";
import RegisterPageTutor from "views/tutorAuth/register.page";
import RecoverPageTutor from "views/tutorAuth/recoverPasswordAsk";
import ActivateTutor from "views/tutorAuth/activate";

//CENTER pages
import RegisterCenter from "views/centers/register.page";
import HomePageCenter from "views/centers/home.page";
import RegisterPDFCenter from "views/centers/pdf.page";
import FinishCeiba from "./views/admin/assessment/finishCeiba";
import FinishTek from "./views/admin/assessment/tek/finishTek";
import FinishCervo from "./views/admin/assessment/cervo/finishCervo";
import InformeCeiba from "./views/admin/informes/informeceiba";
import Informes from "./views/admin/informes/informes";
import InformeCervo from "./views/admin/informes/informecervo";
import InformeTek from "./views/admin/informes/informetek";
import InformeCeibaPDF from "./views/admin/informes/ceiba.pdf.page";
import InformeCervoPDF from "./views/admin/informes/cervo.pdf.page";
import EndXcelence from "./views/admin/assessment/endXcelence";
import EndNogam3 from "./views/admin/assessment/nogam/nogam3/endNogam3";
import EndNogam4 from "./views/admin/assessment/nogam/nogam4/endNogam4";
import EndNogam5 from "./views/admin/assessment/nogam/nogam5/endNogam5";
import EndNogam6 from "./views/admin/assessment/nogam/nogam6/endNogam6";
import Resources from "./views/admin/resources/resources";

import MyFolder from "./views/admin/myFolder/myFolder";
import InformeCeibaSimple from "./views/admin/informes/informeceibasimple";
import InformeCervoSimple from "./views/admin/informes/informecervosimple";
import InformeTekSimple from "./views/admin/informes/informeteksimple";
import DownloadInforme from "./views/admin/informes/informedown";
import ResponsesCeiba from "./views/admin/tutor/tabs/responses.ceiba";
import ResponsesCervo from "./views/admin/tutor/tabs/responses.cervo";
import ResponsesTek from "./views/admin/tutor/tabs/responses.tek";
import ResponsesRest from "./views/admin/tutor/tabs/responses.rest";
import CeibaInstructions from "./views/admin/assessment/ceibaInstructions";
import CervoInstructions from "./views/admin/assessment/cervo/steps/cervoinstructions";
import TekInstructions from "./views/admin/assessment/tek/steps/TekInstructions";
import DownloadAllExcelTable from "./views/admin/informes/datos/exceltabledown";
const dashboardRoutes = [
  {
    path: "/dexcel",
    name: "DownloadAllExcelTable",

    component: DownloadAllExcelTable,
    layout: "/admin",
  },
  {
    path: "/excel",
    name: "DescargaExcel",

    component: DescargaExcel,
    layout: "/admin",
  },
  {
    path: "/assessment",
    name: "QuestionnairePage",

    component: QuestionnairePage,
    layout: "/admin",
  },
  {
    path: "/end-xcelence",
    name: "EndXcelence",

    component: EndXcelence,
    layout: "/admin",
  },
  {
    path: "/end-nogam3",
    name: "EndNogam3",

    component: EndNogam3,
    layout: "/admin",
  },
  {
    path: "/end-nogam4",
    name: "EndNogam4",

    component: EndNogam4,
    layout: "/admin",
  },
  {
    path: "/end-nogam5",
    name: "EndNogam5",

    component: EndNogam5,
    layout: "/admin",
  },
  {
    path: "/end-nogam6",
    name: "EndNogam6",

    component: EndNogam6,
    layout: "/admin",
  },
  {
    path: "/end-ceiba",
    name: "EndCeibaPage",

    component: EndCeibaPage,
    layout: "/admin",
  },
  {
    path: "/start-ceiba",
    name: "StartCeibaPage",

    component: StartCeibaPage,
    layout: "/admin",
  },
  {
    path: "/start-tek",
    name: "StartTekPage",

    component: StartTekPage,
    layout: "/admin",
  },
  {
    path: "/start-cervo",
    name: "StartCervoPage",

    component: StartCervoPage,
    layout: "/admin",
  },
  {
    path: "/end-cervo",
    name: "EndCervoPage",

    component: EndCervoPage,
    layout: "/admin",
  },
  {
    path: "/cervo-game",
    name: "CervoGame",
    component: CervoGame,
    layout: "/admin",
  },
  {
    path: "/finish-cervo",
    name: "FinishCervo",

    component: FinishCervo,
    layout: "/admin",
  },
  {
    path: "/xcelence",
    name: "StartXcelencePage",

    component: StartXcelencePage,
    layout: "/admin",
  },
  {
    path: "/nogam3",
    name: "StartNogam3Page",

    component: StartNogam3Page,
    layout: "/admin",
  },
  {
    path: "/nogam4",
    name: "StartNogam4Page",

    component: StartNogam4Page,
    layout: "/admin",
  },
  {
    path: "/nogam5",
    name: "StartNogam5Page",

    component: StartNogam5Page,
    layout: "/admin",
  },
  {
    path: "/nogam6",
    name: "StartNogam6Page",

    component: StartNogam6Page,
    layout: "/admin",
  },
  {
    path: "/ceiba",
    name: "CeibaPage",

    component: CeibaPage,
    layout: "/admin",
  },
  {
    path: "/cervo-instructions",
    name: "CervoInstructions",

    component: CervoInstructions,
    layout: "/admin",
  },

  {
    path: "/tek-instructions",
    name: "TekInstructions",

    component: TekInstructions,
    layout: "/admin",
  },

  {
    path: "/ceiba-instructions",
    name: "CeibaInstructions",

    component: CeibaInstructions,
    layout: "/admin",
  },

  {
    path: "/tek",
    name: "TekPage",

    component: TekPage,
    layout: "/admin",
  },
  {
    path: "/cervo",
    name: "CervoPage",

    component: CervoPage,
    layout: "/admin",
  },
  {
    path: "/index",
    name: "IndexPage",

    component: IndexPage,
    layout: "/default",
  },
  {
    path: "/contact",
    name: "ContactPage",

    component: ContactPage,
    layout: "/default",
  },
  {
    path: "/redirect",
    name: "RedirectPage",

    component: RedirectPage,
    layout: "/default",
  },
  /******************STUDENT AUTH*************/

  {
    path: "/login",
    name: "Login",

    component: LoginPage,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "RegisterPage",

    component: RegisterPage,
    layout: "/auth",
  },

  {
    path: "/resetPassword",
    name: "ResetPassword",

    component: ResetPassword,
    layout: "/auth",
  },
  {
    path: "/forgot",
    name: "ForgotPassword",

    component: RecoverPage,
    layout: "/auth",
  },
  /************* CENTER ******************/
  {
    path: "/center",
    name: "RegisterCenter",

    component: RegisterCenter,
    layout: "/auth",
  },
  {
    path: "/center/pdf",
    name: "RegisterPDFCenter",

    component: RegisterPDFCenter,
    layout: "/auth",
  },

  {
    path: "/centerHome",
    name: "CenterHome",

    component: HomePageCenter,
    layout: "/auth",
  },
  /******************TUTOR AUTH*************/
  {
    path: "/login",
    name: "Login",

    component: LoginPageTutor,
    layout: "/tutorAuth",
  },
  {
    path: "/home",
    name: "TutorHome",

    component: HomePageTutor,
    layout: "/tutorAuth",
  },
  {
    path: "/register",
    name: "RegisterPage",

    component: RegisterPageTutor,
    layout: "/tutorAuth",
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",

    component: ResetPasswordTutor,
    layout: "/tutorAuth",
  },
  {
    path: "/forgot",
    name: "ForgotPassword",

    component: RecoverPageTutor,
    layout: "/tutorAuth",
  },
  {
    path: "/activate",
    name: "ActivateTutor",

    component: ActivateTutor,
    layout: "/tutorAuth",
  },

  {
    path: "/family",
    name: "LoginFamily",

    component: LoginFamily,
    layout: "/auth",
  },
  {
    path: "/activatecenter",
    name: "ActivateCenter",

    component: ActivateCenter,
    layout: "/tutorAuth",
  },
  {
    path: "/students",
    name: "StudentsPage",

    component: StudentsPage,
    layout: "/tutorAuth",
  },
  /****DASHBOARD **************/
  {
    path: "/dashboard",
    name: "DashboardPage",

    component: DashboardPage,
    layout: "/admin",
  },

  /****INFORMES **************/
  {
    path: "/informes/ceiba",
    name: "InformeCeiba",

    component: InformeCeiba,
    layout: "/admin",
  },
  {
    path: "/responses/:question",
    name: "ResponsesRest",

    component: ResponsesRest,
    layout: "/admin",
  },

  {
    path: "/responses/CEIBA",
    name: "ResponsesCeiba",

    component: ResponsesCeiba,
    layout: "/admin",
  },
  {
    path: "/responses/CERVO",
    name: "ResponsesCervo",

    component: ResponsesCervo,
    layout: "/admin",
  },

  {
    path: "/informes/dceiba",
    name: "InformeCeibaSimple",

    component: InformeCeibaSimple,
    layout: "/admin",
  },
  {
    path: "/informes/pdf/ceiba",

    name: "InformeCeibaPDF",

    component: InformeCeibaPDF,
    layout: "/default",
  },
  {
    path: "/informes/cervo",
    name: "InformeCervo",

    component: InformeCervo,
    layout: "/admin",
  },
  {
    path: "/informes/dcervo",
    name: "InformeCervoSimple",

    component: InformeCervoSimple,
    layout: "/admin",
  },
  {
    path: "/recursos",
    name: "Resources",

    component: Resources,
    layout: "/admin",
  },

  {
    path: "/mensajes",
    name: "Mensajes",

    component: Messages,
    layout: "/admin",
  },

  {
    path: "/cuenta",
    name: "Cuenta",

    component: AccountUserView,
    layout: "/admin",
  },
  {
    path: "/carpeta",
    name: "MyFolder",

    component: MyFolder,
    layout: "/admin",
  },
  {
    path: "/informes/pdf/cervo",
    name: "InformeCervoPDF",

    component: InformeCervoPDF,
    layout: "/admin",
  },

  {
    path: "/informes/dtek",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },

  {
    path: "/informes/dinformes",
    name: "DownloadInforme",

    component: DownloadInforme,
    layout: "/admin",
  },

  {
    path: "/responses/TEK3ESO",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },
  {
    path: "/responses/TEK4ESO",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },
  {
    path: "/responses/TEK1BAC",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },
  {
    path: "/responses/TEK2BAC",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },

  {
    path: "/responses/TEKFPB",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },

  {
    path: "/responses/TEKFPM",
    name: "ResponsesTek",

    component: ResponsesTek,
    layout: "/admin",
  },

  {
    path: "/informes/dTEK3ESO",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },
  {
    path: "/informes/dTEK4ESO",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },
  {
    path: "/informes/dTEK1BAC",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },
  {
    path: "/informes/dTEK2BAC",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },
  {
    path: "/informes/dTEKFPB",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },
  {
    path: "/informes/dTEKFPM",
    name: "InformeTekSimple",

    component: InformeTekSimple,
    layout: "/admin",
  },

  {
    path: "/informes/tek",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },

  {
    path: "/informes/TEK3ESO",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },
  {
    path: "/informes/TEK4ESO",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },
  {
    path: "/informes/TEK1BAC",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },
  {
    path: "/informes/TEK2BAC",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },
  {
    path: "/informes/TEKFPB",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },
  {
    path: "/informes/TEKFPM",
    name: "InformeTek",

    component: InformeTek,
    layout: "/admin",
  },

  {
    path: "/informes",
    name: "Informes",
    component: Informes,
    exact: true,
    layout: "/admin",
  },
  {
    path: "/ceiba-game",
    name: "CeibaGame",

    component: CeibaGame,
    layout: "/admin",
  },
  {
    path: "/finish-ceiba",
    name: "FinishCeiba",

    component: FinishCeiba,
    layout: "/admin",
  },
  {
    path: "/finish-tek",
    name: "FinishTek",

    component: FinishTek,
    layout: "/admin",
  },

  {
    path: "/questionnaires",
    name: "QuestionnairePage",

    component: QuestionnairePage,
    layout: "/admin",
  },

  {
    path: "/assessment/:id",
    name: "AssessmentPage",

    component: AssessmentPage,
    layout: "/admin",
  },

  {
    path: "/validateTutor",
    name: "ValidateTutor",

    component: ValidateTutor,
    layout: "/admin",
  },
];

export default dashboardRoutes;
